import { Flex, Tabs } from '@aloft/toolkit-sui';

import { useEffect } from 'react';

import { selectOrder } from '../../../redux/features/selectors/orderSelectors.ts';
import { selectAivArvActiveTab } from '../../../redux/features/selectors/uiSelectors.ts';
import { getAivArvTabStorageKey, setAivArvActiveTab } from '../../../redux/features/uiSlice.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { AivArvActiveTab } from '../../../redux/types.ts';

export const AdjustmentsToolbar = () => {
  const dispatch = useAppDispatch();
  const { hasArvOption, id: orderId } = useAppSelector(selectOrder);
  const activeTab = useAppSelector(selectAivArvActiveTab);

  useEffect(() => {
    if (orderId) {
      try {
        const storageKey = getAivArvTabStorageKey(orderId);
        window.localStorage.setItem(storageKey, activeTab);
      } catch {
        // Ignore localStorage errors (e.g., in private browsing mode)
      }
    }
  }, [activeTab, orderId]);

  const tabs: { label: string; value: AivArvActiveTab }[] = [
    { label: 'All', value: 'all' },
    { label: 'As-Is Value', value: 'aiv' },
    { label: 'After-Repair Value', value: 'arv' },
  ];

  if (!hasArvOption) {
    return null;
  }

  return (
    <Flex paddingTop="0.5rem" width="100%">
      <Tabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={(tab: AivArvActiveTab) => dispatch(setAivArvActiveTab(tab))}
        variant="primary"
      />
    </Flex>
  );
};
